if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      get selectedOptionValues() {
        return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
          ({ dataset }) => dataset.optionValueId
        );
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);
          this.updateSelectedSwatchValue(event);
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
            },
          });
        });
      }

      selectOptionValueByWeight(weight) {
        const normalizedWeight = Number(weight);
        if (Number.isNaN(normalizedWeight) || normalizedWeight <= 0) return false;

        let input = this.querySelector(`.product-form__input--weight input[type="radio"][data-weight="${normalizedWeight}"]`);

        // Rueckfallebene (17.10.2026): Die Klasse product-form__input--weight
        // und data-weight haengen an attach_weight_picker, und das Flag ist
        // auf der Produktseite false (block.settings.weight_title leer, siehe
        // CLAUDE.md). Der Selektor oben fand deshalb NIE etwas — die
        // Auto-Uebernahme der Rechner-Empfehlung war still tot, Kunden
        // mussten das empfohlene Gewicht selbst anklicken. Hier deshalb
        // zusaetzlich ueber den sichtbaren Optionswert ("8 kg") suchen.
        if (!input) {
          const muster = new RegExp('^\\s*' + normalizedWeight + '\\s*kg\\s*$', 'i');
          input = Array.from(this.querySelectorAll('input[type="radio"]')).find(
            (radio) => muster.test(radio.value) && !radio.classList.contains('disabled')
          );
        }

        if (!input || input.checked) return false;

        input.checked = true;
        this.updateSelectedSwatchValue({ target: input });
        input.dispatchEvent(new Event('change', { bubbles: true }));

        return true;
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute('selected'))
            .removeAttribute('selected');
          target.selectedOptions[0].setAttribute('selected', 'selected');

          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            .querySelector('[data-selected-value] > .swatch');
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const fieldset = target.closest('.product-form__input');
          const selectedByName = fieldset?.querySelector('[data-selected-swatch-value]');

          if (selectedByName) selectedByName.textContent = value;

          const selectedSwatchValue = fieldset?.querySelector('[data-selected-value]');
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
      }
    }
  );
}
